import {
  selectionLabel,
  type Fixture,
  type FixtureEvent,
  type MarketDef,
  type Outcome,
  type PredictionLeg
} from '@h2h/shared';

export function teamCode(name: string, code?: string): string {
  if (code) return code;
  return name.replace(/[^A-Za-z]/g, '').slice(0, 3).toUpperCase() || name.slice(0, 3).toUpperCase();
}

/** The 1X2 base, in words. */
export function outcomeWord(o: Outcome, home: string, away: string): string {
  if (o === 'HOME') return `${home} win`;
  if (o === 'AWAY') return `${away} win`;
  return 'Draw';
}

/** The display value for one boost (option label, scorer name, or exact score). */
export function legValue(leg: PredictionLeg, m: MarketDef, fixture: Fixture): string {
  if (m.kind === 'player') return leg.label ?? 'Your scorer';
  if (m.kind === 'exact') return leg.selection;
  return selectionLabel(leg.marketId, leg.selection, { home: fixture.homeTeam, away: fixture.awayTeam });
}

export function kickoffLabel(ms: number): string {
  const d = new Date(ms);
  const day = d.toLocaleDateString('en-GB', { weekday: 'short' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${day} ${time}`;
}

export function topOutcome(o: { HOME: number; DRAW: number; AWAY: number }): string {
  const max = Math.max(o.HOME, o.DRAW, o.AWAY);
  if (o.HOME === max) return 'a home win';
  if (o.AWAY === max) return 'an away win';
  return 'a draw';
}

export function topShare(o: { HOME: number; DRAW: number; AWAY: number }): number {
  return Math.max(o.HOME, o.DRAW, o.AWAY);
}

export function minuteLabel(e: FixtureEvent): string {
  return e.extra ? `${e.elapsed}+${e.extra}'` : `${e.elapsed}'`;
}

export function eventKind(e: FixtureEvent): string {
  switch (e.type) {
    case 'GOAL':
      return e.detail;
    case 'CARD':
      return e.detail;
    case 'SUBST':
      return 'Substitution';
    case 'VAR':
      return e.detail || 'VAR';
    default:
      return e.team;
  }
}

export function fmtStat(v: number | null, percent?: boolean, decimals?: number): string {
  if (v == null) return '—';
  const n = decimals ? v.toFixed(decimals) : String(Math.round(v));
  return percent ? `${n}%` : n;
}
